import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { SourcesPage } from './pages/SourcesPage';
import { RegistryPage } from './pages/RegistryPage';
import { ReconciliationPage } from './pages/ReconciliationPage';
import { OverviewPage } from './pages/OverviewPage';
import { GPOPage } from './pages/GPOPage';
import { AssetsPage } from './pages/AssetsPage';
import { ATOPage } from './pages/ATOPage';
import { LicensesPage } from './pages/LicensesPage';
import { ToilPage } from './pages/ToilPage';
import { PacingPage } from './pages/PacingPage';
import { CampaignsPage } from './pages/CampaignsPage';
import { MIMPage } from './pages/MIMPage';
import { ExceptionsPage } from './pages/ExceptionsPage';
import { DomainHealthPage } from './pages/DomainHealthPage';
import { ADWastePage } from './pages/ADWastePage';
import { AwsDashboardPage } from './pages/AwsDashboardPage';
import { CostSavingsPage } from './pages/CostSavingsPage';
import { ServiceNowAnalyticsPage } from './pages/ServiceNowAnalyticsPage';
import { KPIAnalyticsPage } from './pages/KPIAnalyticsPage';
import { TaskersPage } from './pages/TaskersPage';
import { SettingsPage } from './pages/SettingsPage';
import { TeamsPage } from './pages/TeamsPage';
import CalendarPage from './pages/CalendarPage';
import IngestQueuePage from './pages/IngestQueuePage';
import { ReportsPage } from './pages/ReportsPage';
import { WorkspacePage } from './pages/WorkspacePage';
import { InboxPage } from './pages/InboxPage';
import { OrgChartPage } from './pages/OrgChartPage';
import { ButtonTestPage } from './pages/ButtonTestPage';
import OutagePipelinePage from './pages/OutagePipelinePage';
import './styles/org-chart.css';

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/sources" element={<SourcesPage />} />
        <Route path="/registry" element={<RegistryPage />} />
        <Route path="/reconciliation" element={<ReconciliationPage />} />
        <Route path="/gpo" element={<GPOPage />} />
        <Route path="/outages" element={<Navigate to="/domain-health?tab=outages" replace />} />
        <Route path="/assets" element={<AssetsPage />} />
        <Route path="/discovery" element={<Navigate to="/assets?tab=discovery" replace />} />
        <Route path="/ato" element={<ATOPage />} />
        <Route path="/licenses" element={<LicensesPage />} />
        <Route path="/toil" element={<ToilPage />} />
        <Route path="/pacing" element={<PacingPage />} />
        <Route path="/campaigns" element={<CampaignsPage />} />
        <Route path="/mim" element={<MIMPage />} />
        <Route path="/exceptions" element={<ExceptionsPage />} />
        <Route path="/domain-health" element={<DomainHealthPage />} />
        <Route path="/outage-pipeline" element={<OutagePipelinePage />} />
        <Route path="/outage-pipeline/:incidentId" element={<OutagePipelinePage />} />
        <Route path="/outage-pipeline/:incidentId/:channel" element={<OutagePipelinePage />} />
        <Route path="/ad-waste" element={<ADWastePage />} />
        <Route path="/pipeline" element={<Navigate to="/settings?tab=datasources&section=pipeline" replace />} />
        <Route path="/aws" element={<AwsDashboardPage />} />
        <Route path="/cost-savings" element={<CostSavingsPage />} />
        <Route path="/servicenow-analytics" element={<ServiceNowAnalyticsPage />} />
        <Route path="/kpi-analytics" element={<KPIAnalyticsPage />} />
        <Route path="/taskers" element={<TaskersPage />} />
        <Route path="/servicenow-feed" element={<Navigate to="/servicenow-analytics?tab=feed" replace />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/teams" element={<TeamsPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/ingest-queue" element={<IngestQueuePage active={true} />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/workspace" element={<WorkspacePage />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/org-chart" element={<OrgChartPage />} />
        <Route path="/button-test" element={<ButtonTestPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
